module.exports = __webpack_public_path__ + "static/grantProfile-f23fd45a265fee532492871c8be30dd3.png";